import { Injectable } from '@angular/core';
import { dropdownItems, UtilService } from './util.service';
import { IndexdbRepository } from '../repositorio/indexdb.repository';
import { DropdownItem } from 'primeng/dropdown';

@Injectable({
  providedIn: 'root'
})
export class IndexdbService extends IndexdbRepository {

  constructor(
    private readonly util: UtilService
  ) {
    super();
  }

  data
  override  async getDropdownItemByType(type: string): Promise<dropdownItems[]> {
    this.data = []
    this.data = await this.util.obtenerDatos([{ tipo: type }])
    const resultado: dropdownItems[] = []
    this.data.map(r => {
      const item: dropdownItems = { label: r.nombre, value: r.codigo }
      resultado.push(item)
    })

    return resultado
  }

  override getAllItemByType(type: string): any[] {
    return null
  }
}
